<template>

    <div class="row">
        <div class="col-md-6 col-lg-4">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">{{ Lang.get("projects.headers.projectdata") }}</h2>
                    <project-favorite
                        :project-uuid="project.uuid"
                        :is-favorite="false"
                        :toggle-favorite-uri="route('api.v1.projects.togglefavorite')"
                    ></project-favorite>
                    <div class="box-tools">
                        <router-link
                            class="btn btn-primary btn-xs"
                            :to="{name:'projects.details.edit', params: {project_uuid: this.project.uuid}}"
                            v-tooltip="Lang.get('projects.editproject')"
                        >
                            <i class="mdi mdi-pencil"></i>
                            <span class="sr-only">{{ Lang.get('projects.editproject') }}</span>
                        </router-link>
                        <delete-button
                            class="btn btn-danger btn-xs"
                            title="Project"
                            :url="route('api.v1.projects.destroy', {project_uuid:this.project.uuid})"
                            :name="project.name"
                            :redirectUri="{name:'projects.index'}"
                            v-tooltip="'Project verwijderen'"
                        >
                            <i class="fa fa-trash"></i>
                            <span class="sr-only">Project verwijderen</span>
                        </delete-button>
                    </div>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <tbody>
                            <tr>
                                <th class="text-right col-lg-3">{{ Lang.get("global.number") }}</th>
                                <td>{{ project.number }}</td>
                            </tr>
                            <tr>
                                <th class="text-right col-lg-3">{{ Lang.get("global.name") }}</th>
                                <td>{{ project.name }}</td>
                            </tr>
                            <tr>
                                <th class="text-right col-lg-3">{{ Lang.get("global.shortname") }}</th>
                                <td>{{ project.shortname }}</td>
                            </tr>
                            <tr>
                                <th class="text-right col-lg-3">{{ Lang.get("projects.source") }}</th>
                                <td>{{ project.source }}</td>
                            </tr>
                            <tr>
                                <th class="text-right col-lg-3">{{ Lang.get("projects.type") }}</th>
                                <td>{{ project.type }}</td>
                            </tr>
                            <tr>
                                <th class="text-right col-lg-3">{{ Lang.get("projects.category") }}</th>
                                <td>{{ project.category }}</td>
                            </tr>
                            <tr>
                                <th class="text-right col-lg-3">{{ Lang.get("global.city") }}</th>
                                <td>{{ project.city }}</td>
                            </tr>
                            <tr>
                                <th class="text-right col-lg-3">{{ Lang.get("global.country") }}</th>
                                <td>{{ project.country }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">{{ Lang.get("projects.headers.projectdetails") }}</h2>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <tbody>
                            <tr>
                                <th class="text-right col-lg-3">{{ Lang.get("global.startdate") }}</th>
                                <td>{{ project.startdate }}</td>
                            </tr>
                            <tr>
                                <th class="text-right col-lg-3">{{ Lang.get("global.enddate") }}</th>
                                <td>{{ project.enddate }}</td>
                            </tr>
                            <tr>
                                <th class="text-right col-lg-3">{{ Lang.get("projects.executiondate") }}</th>
                                <td>{{ project.executiondate }}</td>
                            </tr>
                            <tr>
                                <th class="text-right col-lg-3">{{ Lang.get("projects.buildingtime") }}</th>
                                <td>{{ project.buildingtime }} {{ Lang.get("global.months") }}</td>
                            </tr>
                            <tr>
                                <th class="text-right col-lg-3">{{ Lang.get("projects.buildingarea") }}</th>
                                <td>{{ project.buildingarea }} m2</td>
                            </tr>
                            <tr>
                                <th class="text-right col-lg-3">{{ Lang.get("projects.buildingcosts") }}</th>
                                <td>{{ project.buildingcosts | toCurrency }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-md-6 col-lg-4">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">{{ Lang.get("projects.headers.projectteam") }}</h2>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <tbody>
                            <tr v-if="project.partner !== null">
                                <th class="text-right col-lg-3">{{ Lang.get("global.partner") }}</th>
                                <td>{{ project.partner.fullname }}</td>
                            </tr>
                            <tr v-if="project.director !== null">
                                <th class="text-right col-lg-3">{{ Lang.get("projects.director") }}</th>
                                <td>{{ project.director.fullname }}</td>
                            </tr>
                            <tr v-if="project.team !== null">
                                <th class="text-right col-lg-3">{{ Lang.get("global.team") }}</th>
                                <td>{{ project.team.name }}</td>
                            </tr>
                            <tr>
                                <th class="text-right col-lg-3">{{ Lang.get("global.members") }}</th>
                                <td>
                                    <span v-if="teamMembers.length > 0">
                                        {{ teamMembers.join(', ') }}
                                    </span>
                                    <span v-if="teamMembers.length > 0 && teamExtraMembers.length > 0">
                                        <br /><strong>Extra:</strong>
                                    </span>
                                    <span v-if="teamExtraMembers.length > 0">
                                        {{ teamExtraMembers.join(', ') }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">{{ Lang.get("projects.headers.projectstatus") }}</h2>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <tbody>
                            <tr>
                                <th class="text-right col-lg-3">{{ Lang.get("global.status") }}</th>
                                <td>{{ project.status }}</td>
                            </tr>
                            <tr>
                                <th class="text-right col-lg-3">{{ Lang.get("projects.completion_percentage") }}</th>
                                <td>{{ project.completion_percentage }}%</td>
                            </tr>
                            <tr>
                                <th class="text-right col-lg-3">{{ Lang.get("projects.budget") }}</th>
                                <td>{{ project.budget | toCurrency }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Notities</h2>
                </div>

                <div
                    v-if="project.notes.length === 0"
                    class="box-body"
                >
                    <p>Er zijn geen notities gevonden voor dit project.</p>
                </div>
                <div
                    v-else
                    class="box-body no-padding"
                >
                    <table class="table table-striped">
                        <tbody class="crmNotesList">
                            <tr
                                v-for="note in project.notes"
                                :key="'projectnote-' + note.uuid"
                            >
                                <td colspan="3">
                                    <div>
                                        <p>
                                            <strong>Door:</strong>

                                            <s
                                                v-if="note.creator.active === false"
                                                v-tooltip="'Deze medewerker werkt hier niet meer'"
                                            >
                                                {{ note.creator.fullname }}
                                            </s>
                                            <span
                                                v-else
                                            >
                                                {{ note.creator.fullname }}
                                            </span>
                                        </p>
                                        <p>
                                            <strong>Datum:</strong>
                                            {{ note.created_at | formatDateTime }}
                                        </p>
                                        <p><strong>Notitie:</strong></p>
                                        <div v-html="note.note"></div>
                                        <div
                                            v-if="note.permissions.delete"
                                            class="text-right"
                                        >
                                            <delete-button
                                                :url="route('api.v1.projects.notes.delete', {project_uuid: project.uuid, uuid: note.uuid})"
                                                :title="Lang.get('notes.show.note')"
                                                :name="Lang.get('notes.show.noteby') + ' ' + note.creator.fullname"
                                                :parent-element="'projectnote-' + note.uuid"
                                                v-tooltip="'Notitie verwijderen'"
                                                @delete-completed="$emit('reloadProjectData')"
                                            ></delete-button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <add-note
                v-if="canAddNote"
                :post-url="route('api.v1.projects.notes.add', {project_uuid:project.uuid})"
                :user-name="getAuth.fullname"
                @noteAdded="$emit('reloadProjectData')"
            ></add-note>
        </div>
        <div class="col-md-6 col-lg-4">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">{{ Lang.get("projects.headers.projectcontacts") }}</h2>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th class="col-lg-3">{{ Lang.get("projects.type") }}</th>
                                <th>{{ Lang.get("global.contact") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="contact in project.contacts">
                                <td class="text-right">{{ contact.type }}</td>

                                <td v-if="contact.contact === null">&ndash;</td>
                                <td v-else>
                                    <router-link
                                        v-if="contact.contact.is_contact"
                                        :to="{path:contact.contact.itemUri}"
                                    >
                                        {{ contact.contact.full_name }}
                                        <span v-if="contact.contact.company_name !== ''">
                                            ({{ contact.contact.company_name }})
                                        </span>
                                    </router-link>
                                    <router-link
                                        v-else
                                        :to="{path:contact.contact.itemUri}"
                                    >
                                        {{ contact.contact.company_name }}
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import { mapGetters } from 'vuex';
import Lang from '../../../Lang';
import AddNote from "../../../components/CRM/AddNote";

export default {

    components: {
        AddNote,
    },

    computed: {
        ...mapGetters([
            'getAuth',
            'getProject',
        ]),

        canAddNote() {
            return this.getProject.access.notes.add;
        },

        project() {
            return this.getProject;
        },

        teamMembers() {
            return this.project.team_members.map(user => user.fullname).sort();
        },

        teamExtraMembers() {
            return this.project.team_extra_members.map(user => user.fullname).sort();
        },
    },

    data() {
        return {
            Lang:Lang,
        }
    },

    metaInfo: {
        title:'Project details',
    },

    name:'ProjectsDetailsIndex',

}

</script>
